<template>
    <div>
        <PasoExtraRecintoAnexo
            v-if="!show_svg_plazas_parking"
            key="pasoExtraRA"
            id="pasoExtraRA"
            :texto_producto_extra="$t('nuevo_abono.parking_extra')"
            @continuarProductoExtra="avanzarPaso"
        />

        <template v-if="show_svg_plazas_parking">
            <SeleccionarAsientosConRegiones 
                v-if="tipoProcesoOnline == 1"
                :disabled="disabled"
                :changeSeat="changeSeat" 
                :abonado="abonado" 
                :recuperarSoloZonaAnexas="true"
                @butacasBloqueadas="butacasBloqueadas"
                @sessionButacaData="sessionButacaDataPadre"
                @continuarSinPlazaParking="continuarSinPlazaParking"
            />
            <SeleccionarAsientoConSecciones 
                v-if="tipoProcesoOnline == 2"
                :disabled="disabled"
                :changeSeat="changeSeat" 
                :abonado="abonado" 
                :recuperarSoloZonaAnexas="true"
                @butacasBloqueadas="butacasBloqueadas"
                @continuarSinPlazaParking="continuarSinPlazaParking"
            />
            <div class="container mb-3 text-right">
                <button class="btn btn-outline-secondary" @click="volverASeleccionButacas">
                    <i class="fa fa-redo"></i> {{ $t('nuevo_abono.volver_compra') }}
                </button>
            </div>

        </template>
    </div>
</template>

<script>
    import PasoExtraRecintoAnexo from '../../events/compra/components/recinto-anexo/PasoExtraRecintoAnexo.vue';
    import SeleccionarAsientosConRegiones from '@/components/frontend/abonos/nuevo/SeleccionarAsientosConRegiones.vue';
    import SeleccionarAsientoConSecciones from '@/components/frontend/abonos/nuevo/SeleccionarAsientoConSecciones.vue';

    export default {
        props: {
            disabled: {
                type: Boolean,
                required: true
            },
            changeSeat: {
                type: Number,
                required: true
            },
            abonado: {
                type: [Object, null],
                required: false
            },
            tipoProcesoOnline: {
                type: Number,
                required: false,
                default: 1
            }
        },
        data() {
            return {
                show_svg_plazas_parking: false
            }
        },
        methods: {
            avanzarPaso(quiere_plaza) {
                if (quiere_plaza) {
                    this.show_svg_plazas_parking = true;
                }
                this.$emit('avanzarPaso', quiere_plaza);
            },
            butacasBloqueadas(datos_compradores, asientos, zona, session_id, zonas_anexas) {
                this.$emit('butacasBloqueadas', datos_compradores, asientos, zona, session_id, zonas_anexas);
            },
            sessionButacaDataPadre(data) {
                this.$emit('sessionButacaData', data);
            },
            continuarSinPlazaParking() {
                this.show_svg_plazas_parking = false;
                this.$emit('continuarSinPlazaParking');
            },
            volverASeleccionButacas() {
                this.show_svg_plazas_parking = false;
                // El padre escucha `volverButacas` desde hace tiempo, pero nadie lo
                // emitía: el botón de volver del parking no hacía nada.
                this.$emit('volverButacas');
            }
        },
        components: {
            PasoExtraRecintoAnexo, SeleccionarAsientosConRegiones, SeleccionarAsientoConSecciones
        }
    }
</script>